import type { LeadAttribution } from '~/types/lead';

export const TRACKED_QUERY_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

export function buildLeadAttribution(data: Record<string, FormDataEntryValue | string | undefined>): LeadAttribution {
  const getValue = (key: string) => {
    const value = data[key];
    return typeof value === 'string' && value.trim() ? value.trim() : undefined;
  };

  return {
    utmSource: getValue('utm_source'),
    utmMedium: getValue('utm_medium'),
    utmCampaign: getValue('utm_campaign'),
    utmTerm: getValue('utm_term'),
    utmContent: getValue('utm_content'),
    referrer: getValue('referrer'),
    firstLandingPage: getValue('first_landing_page'),
    currentPage: getValue('current_page'),
    currentPageTitle: getValue('current_page_title'),
  };
}

export function getAttributionStorageKey() {
  return 'showhive-attribution';
}
